export default __webpack_public_path__ + "static/media/house-16.46f2da25.jpg";